import {useIntl} from 'react-intl';
import {DatedEvidence, TableCells, TableColumn} from '@eas/common-web';
import {EsFileReturnLog} from '@models';

const stateLabel: Record<string, string> = {
  IN_PROGRESS: 'Probíhá',
  INTERRUPTED: 'Přerušeno',
  COMPLETED: 'Dokončeno',
  COMPLETED_WITH_FAILURES: 'Dokončeno s chybami',
  FAILED: 'Selhalo',
};

function getStateId(value: any) {
  return typeof value === 'string' ? value : value?.id;
}

function getStateLabel(value: any) {
  if (typeof value === 'string') {
    return stateLabel[value] ?? value;
  }

  return value?.label ?? stateLabel[getStateId(value) ?? ''] ?? value?.name ?? '-';
}

export function useColumns(): TableColumn<EsFileReturnLog>[] {
  const intl = useIntl();
  const { columnCreated } = DatedEvidence.useDatedColumns<EsFileReturnLog>();

  return [
    columnCreated,
    {
      datakey: 'description',
      name: intl.formatMessage({
        id: 'ES__ES_FILE_RETURN_LOG__TABLE__COLUMN__DESCRIPTION',
        defaultMessage: 'Popis',
      }),
      width: 320,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'state',
      filterkey: 'state.id',
      sortkey: 'state.name',
      name: intl.formatMessage({
        id: 'ES__ES_FILE_RETURN_LOG__TABLE__COLUMN__STATE',
        defaultMessage: 'Stav',
      }),
      width: 170,
      CellComponent: (props) =>
        TableCells.TextCell({
          ...props,
          value: getStateLabel(props.rowValue?.state),
        }),
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'processedCount',
      name: intl.formatMessage({
        id: 'ES__ES_FILE_RETURN_LOG__TABLE__COLUMN__PROCESSED',
        defaultMessage: 'Zpracováno',
      }),
      width: 120,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'totalCount',
      name: intl.formatMessage({
        id: 'ES__ES_FILE_RETURN_LOG__TABLE__COLUMN__TOTAL',
        defaultMessage: 'Celkem',
      }),
      width: 120,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'failedCount',
      name: intl.formatMessage({
        id: 'ES__ES_FILE_RETURN_LOG__TABLE__COLUMN__FAILED',
        defaultMessage: 'Selhalo',
      }),
      width: 120,
      CellComponent: TableCells.TextCell,
      sortable: true,
      filterable: true,
    },
  ];
}
